import { graphql, useStaticQuery } from 'gatsby';

// Reusable hook for accessing header links
export const useFooter = () => {
	const data = useStaticQuery(
		graphql`
			query {
				contentstackFooter {
					newsletter
					top_row {
						pro_ctas {
							...CTA
						}
						ho_ctas {
							...CTA
						}
					}
					box_cta {
						pro_ctas {
							...CTA
						}
						ho_ctas {
							...CTA
						}
					}
					standard_columns {
						heading
						ho_ctas {
							...CTA
						}
						pro_ctas {
							...CTA
						}
					}
					social {
						ctas {
							...CTA
						}
					}
					warranty {
						...CTA
					}
					copyright {
						heading
						ctas {
							...CTA
						}
					}
					errors {
						...Errors
					}
					customer_type_options
					success_message
				}
			}
		`
	);

	return data.contentstackFooter;
};
